export enum FeatureFlags {
  READ_USER_LANGUAGE = '04dd48669464dda7ec88d56caffa7f6ad9aacf713dee73c51cf5c7eac0f1970a',
  FACTOR_SOFT_CLIENT_AUTOMATION = 'ec68051c728aee7e9712f0866a0f312e2726363e093e5b60b02956d5f3ae508e',
  USE_NEW_REGISTRATION = 'dc787a56b2aa259940ef3e32738466933ecc449a21da992132d7f8af79ccae83',
  PERMISSION_DELETE = '447f9c54a92c235ba7f7af26fa7389ad19cf82e6a3ccd98f94c0e79f7b1539c5',
  CREATE_CASE_FORM = '7c37edfe5e81b9f24193cca1bdf8482cb29eda8026b9fcda859b8892a4ff046c',
  RTS_REBRAND = 'e94c6bb76fbfe69e80589f1d761efa8ef43cecba3a238326805fe56908a5b809',
  FREIGHT_PERMISSIONS_WEB = '8c0995f9ddbfefa867b1d5f6b06263baf82914d0ff22bf209b462f14737b9825',
  EQUIPMENT_FINANCE_CRM = 'dff55a7fb87f7eb93bb9c18fd61636a7c9c6cc61db1a399e33d4f2b6ed5ebeda',
}
